import React, { useCallback, useMemo } from 'react'
import { Button, Card, Space, Typography } from 'antd'
import { DownloadOutlined, FileTextOutlined } from '@ant-design/icons'

const { Text } = Typography

const DownloadConfigComponent = ({ config = '' }) => {
  const fileName = useMemo(() => {
    const timestamp = new Date().getTime()
    return `camera-configuration-${timestamp}.json`
  }, [])

  const handleDownload = useCallback(() => {
    const blob = new Blob([config], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }, [config, fileName])

  return (
    <Card
      bordered
      style={{
        borderRadius: 8,
        padding: '12px 16px',
      }}
    >
      <Space
        align="center"
        style={{ width: '100%', justifyContent: 'space-between' }}
      >
        <Space align="center">
          <FileTextOutlined style={{ fontSize: 20 }} />
          <div>
            <Text strong style={{ display: 'block' }}>
              Configuration File
            </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {fileName}
            </Text>
          </div>
        </Space>

        <Button
          type="primary"
          icon={<DownloadOutlined style={{ color: 'white' }} />}
          onClick={handleDownload}
        >
          Download
        </Button>
      </Space>
    </Card>
  )
}

export default DownloadConfigComponent
